var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 15.05" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_heartrate"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_record" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icons_heartrate" },
            React.createElement(
              "g",
              { id: "icon_heartrate13" },
              React.createElement("path", { id: "item_heartrate1", className: styles["cls-1"] || "cls-1", d: "M.34 6.17H2.8L5 2.87 7 5.8l1-2.09 1.1 2.21 1-1 1 2 .74-.75h3.82a3.79 3.79 0 0 0 .25-.74 3.55 3.55 0 0 0 .09-.88V4A4.11 4.11 0 0 0 14.32.88 4.72 4.72 0 0 0 9.49.49 5.61 5.61 0 0 0 8 1.83 5.61 5.61 0 0 0 6.51.49a4.72 4.72 0 0 0-4.83.39A4.11 4.11 0 0 0 0 4v.56a3.55 3.55 0 0 0 .09.88 3.79 3.79 0 0 0 .25.73z" }),
              React.createElement("path", { id: "item_heartrate2", className: styles["cls-1"] || "cls-1", d: "M12.16 6.92L10.9 8.18l-1-2-1 1L8 5.39 7 7.3 5 4.23 3.2 6.92H.74l.26.41c.22.31.45.62.69.91.49.59 1 1.11 1.29 1.44s1.07 1.1 1.93 2 1.91 2 3.1 3.36a163.596 163.596 0 0 1 5.03-5.36c.41-.41.8-.85 1.29-1.44.24-.29.47-.6.69-.91l.25-.41z" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/iconStroke/images/heartrate.svg
// module id = 1642
// module chunks = 0